import React from 'react';
import TabProvider from './TabProvider';
import Tabs from './Tabs';
import TabContent from './TabContent';
import { Card } from '../../shadcn/ui/card';

const TabbedCard = ({ tabConfig }) => {
    if (tabConfig?.length === 0) {
        return null;
    }
    return (
        <TabProvider tabs={tabConfig ?? []}>
            <Card>
                <Tabs />
                <TabContent />
            </Card>
        </TabProvider>
    );
};

export default TabbedCard;
